import type * as React from 'react';

import * as api from '@gitbook/api-client';
import type { ContentThemeMode } from '@gitbook/app-database';
import { TilePicker } from '@gitbook/spine-react';

import { useUpgradeSite } from '../../../state';
import { PaidFeatureIndicator } from '../../Site/PaidFeatureIndicator';
import type { SitesCustomizationPanelProps } from '../types';
import { SITE_THEMES } from '../utils';

// @site-theme - Keep it synced with backend by grepping that tag.
const PAID_THEMES = ['bold', 'gradient'];

/**
 * Settings to configure the site theme
 */
export function ThemeThumbnails(
    props: SitesCustomizationPanelProps & { previewThemeMode: ContentThemeMode }
): React.ReactElement {
    const { settings, setSettings } = props;

    const upgrade = useUpgradeSite(props.site, api.SiteFeatureKey.SitesAdvancedCustomization);

    return (
        <div className="flex flex-wrap gap-2">
            <TilePicker
                aria-label="Theme"
                items={SITE_THEMES.map((theme) => ({
                    ...theme,
                    trailing: PAID_THEMES.includes(theme.value) && (
                        <PaidFeatureIndicator
                            upgrade={upgrade}
                            isFeatureActive={theme.value === settings.styling.theme}
                        />
                    ),
                }))}
                selectedItem={settings.styling.theme}
                setSelectedItem={(value) => {
                    setSettings((prev) => ({
                        ...prev,
                        styling: {
                            ...prev.styling,
                            theme: value,
                        },
                    }));
                }}
                className="grid w-full grid-cols-2 gap-5"
            />
        </div>
    );
}
